import axios from 'axios'

const API_URL = '/admin/blocks'

class BlockService {
    /**
     * Get list of all blocks
     * @param {Object} params - Query parameters (search, is_active, orientation, per_page)
     * @returns {Promise}
     */
    list(params = {}) {
        return axios.get(API_URL, { params })
    }

    /**
     * Get single block by ID
     * @param {Number|String} id - Block ID
     * @returns {Promise}
     */
    get(id) {
        return axios.get(`${API_URL}/${id}`)
    }

    /**
     * Create new block
     * @param {Object} data - Block data
     * @returns {Promise}
     */
    create(data) {
        return axios.post(API_URL, data)
    }

    /**
     * Update existing block
     * @param {Number|String} id - Block ID
     * @param {Object} data - Block data
     * @returns {Promise}
     */
    update(id, data) {
        return axios.put(`${API_URL}/${id}`, data)
    }

    /**
     * Delete block
     * @param {Number|String} id - Block ID
     * @returns {Promise}
     */
    remove(id) {
        return axios.delete(`${API_URL}/${id}`)
    }

    /**
     * Update sort order for multiple blocks
     * @param {Object} data - Object with items array
     * @returns {Promise}
     */
    updateSortOrder(data) {
        return axios.post(`${API_URL}/sort-order`, data)
    }

    /**
     * Toggle block active status
     * @param {Number|String} id - Block ID
     * @param {Boolean} isActive - New active status
     * @returns {Promise}
     */
    async toggleActive(id, isActive) {
        const block = await this.get(id)
        return this.update(id, {
            ...block.data,
            is_active: isActive
        })
    }

    /**
     * Get blocks by orientation
     * @param {String} orientation - 'horizontal' or 'vertical'
     * @returns {Promise}
     */
    getByOrientation(orientation) {
        return this.list({ orientation })
    }

    /**
     * Duplicate block
     * @param {Number|String} id - Block ID to duplicate
     * @returns {Promise}
     */
    async duplicate(id) {
        const response = await this.get(id)
        const block = response.data

        const newBlock = {
            name_ru: `${block.name_ru} (копия)`,
            name_uk: `${block.name_uk} (копія)`,
            orientation: block.orientation,
            icon: block.icon,
            is_active: false,
            sort_order: block.sort_order + 1,
            products: block.products?.map((product, index) => ({
                product_id: product.id,
                sort_order: index
            })) || []
        }

        return this.create(newBlock)
    }
}

export default new BlockService()